import { render } from "./BoilermakingForm.vue?vue&type=template&id=72f846d9&scoped=true"
import script from "./BoilermakingForm.vue?vue&type=script&lang=js"
export * from "./BoilermakingForm.vue?vue&type=script&lang=js"

import "./BoilermakingForm.vue?vue&type=style&index=0&id=72f846d9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72f846d9"]])

export default __exports__